import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior(to) {
    if(to.hash){
      return { selector:to.hash }
    }else{
      return { y:0 }
    }
  },
  routes: [
    {
        path: '/gsjj',
        redirect: '/aboutus'
    },
    {
        path: '/fzlc',
        redirect: '/aboutus'
    },
    {
        path: '/ryzz',
        redirect: '/aboutus'
    },
    {
        path: '/jssl',
        redirect: '/aboutus'
    },
    {
      path: '/',
      component: ()=>import('@/pages/home/home')
    },
    {
      path: '/core',
      component: ()=>import('@/pages/core/core')
    },
    {
      path: '/aboutus',
      component: ()=>import('@/pages/aboutus/aboutus')
    },
    {
      path: '/solution',
      component: ()=>import('@/pages/solution/solution')
    },
    {
      path: '/callus',
      component: ()=>import('@/pages/callus/callus')
    },
    {
      path: '/drag',
      component: ()=>import('@/pages/drag/drag')
    },
    {
      path: '/login',
      component: ()=>import('@/pages/login/login')
    },
    {
      path: '/admin',
      component: ()=>import('@/pages/admin/admin')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js